import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

export interface PlanLinkTarget {
  id: string
  status: string
  step: number
  workspaceId: string
}

/**
 * One place that decides where a plan opens:
 * completed → workspace roadmap · generating → wizard step 4 (progress) · otherwise → its current wizard step.
 */
export function PlanLink({ plan, className, onClick, children }: { plan: PlanLinkTarget; className?: string; onClick?: () => void; children: ReactNode }) {
  if (plan.status === 'completed') {
    return (
      <Link to="/workspace/$workspaceId/$view" params={{ workspaceId: plan.workspaceId, view: 'roadmap' }} search={{ plan: plan.id }} className={className} onClick={onClick}>
        {children}
      </Link>
    )
  }
  const step = plan.status === 'generating' ? 4 : Math.min(Math.max(plan.step || 2, 1), 5)
  return (
    <Link to="/plans/$planId" params={{ planId: plan.id }} search={{ step }} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
